import { create } from "zustand";
import { FugitiveStoreProps } from "./interface/fugitive.interface";
import {
  getComBySeriesFugitive,
  getEqIdFugitive,
  getFilterEqTypeFugitive,
  getFilterStatusFugitive,
  getFilterSTDControlFugitive,
  getFilterUncheckFugitive,
  getOptionsComBySeriesFugitive,
  getStatusFugitive,
  getSTDControlFugitive,
  getUncheckFugitive,
} from "src/services/settings.service";
import { getVocResult } from "src/services/fugitive.service";

export const fugitiveStore = create<FugitiveStoreProps>((set) => ({
  vocResult: [],
  totalVocResult: 0,
  loadingVocResult: false,
  selectedYearVocResult: new Date().getFullYear(),
  statusFugitive: [],
  filterStatusFugitive: [],
  totalStatusFugitive: 0,
  eqTypeFugitive: [],
  filterEqTypeFugitive: [],
  totalEqTypeFugitive: 0,
  uncheckFugitive: [],
  filterUncheckFugitive: [],
  totalUncheckFugitive: 0,
  stdControlFugitive: [],
  filterStdControlFugitive: [],
  totalStdControlFugitive: 0,
  comBySeriesFugitive: [],
  totalComBySeriesFugitive: 0,
  optionComBySeriesFugitive: [],

  setSelectedYearVocResult: async (value: number) => {
    set(() => ({
      selectedYearVocResult: value,
    }));
  },
  getVocResult: async (query: string) => {
    try {
      set(() => ({ loadingVocResult: true }));

      const response = await getVocResult(query);
      const data = response.data.data.data;
      const total = response.data.data.total;

      set(() => ({
        vocResult: data ?? [],
        totalVocResult: total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      set(() => ({ loadingVocResult: false }));
    }
  },
  getStatusFugitive: async (query: string) => {
    try {
      const response = await getStatusFugitive(query);
      set(() => ({
        statusFugitive: response.data?.data.data ?? [],
        totalStatusFugitive: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterStatusFugitive: async () => {
    try {
      const response = await getFilterStatusFugitive();
      set(() => ({
        filterStatusFugitive: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getEqTypeFugitive: async (query: string) => {
    try {
      const response = await getEqIdFugitive(query);
      set(() => ({
        eqTypeFugitive: response.data?.data.data ?? [],
        totalEqTypeFugitive: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterEqTypeFugitive: async () => {
    try {
      const response = await getFilterEqTypeFugitive();
      set(() => ({
        filterEqTypeFugitive: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getUncheckFugitive: async (query: string) => {
    try {
      const response = await getUncheckFugitive(query);
      set(() => ({
        uncheckFugitive: response.data?.data.data ?? [],
        totalUncheckFugitive: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterUncheckFugitive: async () => {
    try {
      const response = await getFilterUncheckFugitive();
      set(() => ({
        filterUncheckFugitive: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getStdControlFugitive: async (query: string) => {
    try {
      const response = await getSTDControlFugitive(query);
      set(() => ({
        stdControlFugitive: response.data?.data.data ?? [],
        totalStdControlFugitive: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterStdControlFugitive: async () => {
    try {
      const response = await getFilterSTDControlFugitive();
      set(() => ({
        filterStdControlFugitive: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getComBySeriesFugitive: async (query: string) => {
    try {
      const response = await getComBySeriesFugitive(query);
      set(() => ({
        comBySeriesFugitive: response.data?.data.data ?? [],
        totalComBySeriesFugitive: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getOptionComBySeriesFugitive: async (query) => {
    try {
      const response = await getOptionsComBySeriesFugitive(query);
      set(() => ({
        optionComBySeriesFugitive: response.data?.data ?? [],
      }));
    } catch (error) {
      console.error(error);
    }
  },
}));
